import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  stepperKickerLabel: {
    id: "funding-application: stepper label",
    defaultMessage: "Step {currentStep} of {totalSteps}",
    description: "e.g. Step 5 or 7; to show customer where they are in the application process",
  },
});
